<template>
  <div class="c-bullet" :class="[mode]">
    <div v-if="mode === 'wrong'" class="cnt">
      <div class="wrong__axis"></div>
      <div class="wrong__axis wrong__axis--y"></div>
    </div>
    <div
      v-if="mode === 'correct' || mode === 'primary-correct'"
      :style="{ borderColor: mode === 'primary-correct' ? colors.primary : '' }"
      class="cnt"
    >
      <div
        class="correct__short"
        :style="{
          backgroundColor: mode === 'primary-correct' ? colors.primary : ''
        }"
      ></div>
      <div
        class="correct__long"
        :style="{
          backgroundColor: mode === 'primary-correct' ? colors.primary : ''
        }"
      ></div>
    </div>
    <div
      v-if="mode === 'default' || mode === 'current'"
      :class="{
        'btn-primary': mode === 'current',
        'btn-outline-primary': mode === 'default'
      }"
      class="cnt cnt--defualt "
    ></div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "CheckCircle",
  props: ["mode"],
  computed: {
    ...mapGetters(["colors"])
  }
};
</script>
<style lang="scss">
div.cnt.cnt--defualt {
  top: -2px;
  left: -2px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border-width: 2px;
  border-style: solid;
  &.btn-outline-primary:hover {
    background-color: transparent;
  }
  &:active {
    background-color: transparent;
  }
}
</style>
<style lang="scss" scoped>
.c-bullet {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border-width: 2px;
  border-style: solid;
  margin: 0 5px;
  position: relative;
}
.cnt {
  position: relative;
  width: 100%;
  height: 100%;
}

.correct {
  border-color: #45a71f;
}
.correct__short {
  position: absolute;
  top: 8px;
  left: 3px;
  height: 2px;
  width: 5px;
  transform: rotate(-135deg);
  background-color: #45a71f;
}

.correct__long {
  position: absolute;
  top: 7px;
  left: 5px;
  height: 2px;
  width: 8px;
  transform: rotate(-45deg);
  background-color: #45a71f;
}
.wrong {
  border-color: #f54f4f;
}
.wrong__axis {
  position: absolute;
  top: 7px;
  left: 3px;
  transform: rotate(-135deg);
  height: 2px;
  width: 10px;
  background-color: #f54f4f;
}
.wrong__axis--y {
  transform: rotate(-45deg);
}
</style>
